//? import statements
import { FaQuoteRight } from "react-icons/fa";
//? styles
import styles from "./review.module.css";

const Review = (props) => {
  const {name, job, image, text } = props;

  return (
    <>
      <div className={styles["image-container"]}>
        <img
          src={image}
          alt={name}
          id={styles["image"]}
        />
        <div
          className={styles["quote-icon-container"]}
        >
          <FaQuoteRight
            id={styles["quote-icon"]}
          />
        </div>
      </div>

      <div className={styles["description"]}>
        <h2 id={styles["name"]}>{name}</h2>
        <h2 id={styles["job"]}>{job}</h2>
        <p id={styles["review"]}>{text}</p>
      </div>
    </>
  );
};

export default Review;
